import { PlayerMode } from '../../../services/course-player.service';

/**
 * KAN-127 Phase 2: shouldShowPoints is now the single implementation in
 * src/app/shared/utils/score-display.utils.ts (includes total===0 guard,
 * snake_case aliases, and the full migration-056 heuristic).
 *
 * Re-exported here for any external callers that still import from this module.
 * The SplitScreenPlayerComponent itself has been migrated to import directly
 * from score-display.utils.ts.
 */
export { shouldShowPoints } from '../../utils/score-display.utils';

/**
 * Helper to get earned points from progress data (handles multiple naming conventions).
 */
export function getEarnedPoints(data: any): number | null {
  if (!data) return null;
  const value = data?.quizEarnedPoints ?? data?.quiz_earned_points ?? data?.earnedPoints ?? data?.earned_points;
  if (value === null || value === undefined) return null;
  return typeof value === 'string' ? parseFloat(value) : value;
}

/**
 * Helper to get total points from progress data (handles multiple naming conventions).
 */
export function getTotalPoints(data: any): number | null {
  if (!data) return null;
  const value = data?.quizTotalPoints ?? data?.quiz_total_points ?? data?.totalPoints ?? data?.total_points;
  if (value === null || value === undefined) return null;
  return typeof value === 'string' ? parseFloat(value) : value;
}

/**
 * Get display information for a player mode.
 */
export function getModeDisplayInfo(mode: PlayerMode): { name: string; description: string; color: string } {
  switch (mode) {
    case 'learner':
      return {
        name: 'Learner Mode',
        description: 'Full restrictions, progress saved',
        color: 'text-primary'
      };
    case 'instructor_preview':
      return {
        name: 'Preview Mode',
        description: 'No restrictions, testing only',
        color: 'text-warning'
      };
    case 'instructor_test':
      return {
        name: 'Test Mode',
        description: 'Student experience + debug info',
        color: 'text-info'
      };
    default:
      return {
        name: 'Unknown Mode',
        description: '',
        color: 'text-base-content'
      };
  }
}
